import { render, staticRenderFns } from "./order-type-specific-settings.vue?vue&type=template&id=1ae15670"
import script from "./order-type-specific-settings.vue?vue&type=script&lang=js"
export * from "./order-type-specific-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports